import * as React from 'react';
import { useIntl } from 'react-intl';
import { useLocation, useRoute } from 'wouter';
import { useRecoilValue } from 'recoil';
import { IDynamicTableAddButton } from '../../../interfaces/tables';
import CostsOverviewForm from './CostsOverviewForm';
import DynamicTable from '../../DynamicTable';
import { TABLE_OPERATING_COSTS } from '../../../Services/TableService';
import useUrlQueryParams from '../../../hooks/useUrlQueryParams';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import PermissionsService, { PERMISSION_COST } from '../../../Services/PermissionsService';
import { selectedCustomersAtom } from '../../../store/recoil/customers';
import PageHeader from '../../PageHeader';

export default function OperatingCostsOverView() {
  const { formatMessage: f } = useIntl();
  const [isSubpageOpened, setIsSubpageOpened] = React.useState<boolean>(false);
  const [callTable, setCallTable] = React.useState<boolean>(false);
  const [pathname, navigate] = useLocation();
  const [, params] = useRoute('/costs/edit/:id');
  const query = useUrlQueryParams();
  const customerIdUrl = query.get('customerId');
  const { setDocumentTitle } = useDocumentTitle();
  const selectedCustomers = useRecoilValue<number[]>(selectedCustomersAtom);

  const handleClose = () => {
    setIsSubpageOpened(false);
    // setCostOverviewId(null);
    navigate('/costs');
  };

  const updateTable = () => {
    setCallTable(true);
  };

  const handleSubpage = (id: number, isEdited: boolean, customerValue?: number) => {
    if (isEdited && id && customerValue) {
      setIsSubpageOpened(true);
      // setCostOverviewId(id || null);
      // setIsEdit(true);
      setCallTable(false);
      // setCustomerId(customerValue || null);
    } else {
      setIsSubpageOpened(true);
      // setIsEdit(false);
      setCallTable(false);
    }
  };

  const buttons: IDynamicTableAddButton = {
    costsOverview: {
      open: ['addCostsOverview'],
    },
  };

  React.useEffect(() => {
    if (pathname === '/costs') {
      setIsSubpageOpened(false);
      const documentTitle = `${f({
        id: 'menu.costsOverview',
      })} - ${f({
        id: 'menu.costs',
      })}`;
      setDocumentTitle(documentTitle);
    } else if (pathname === '/costs/add') {
      setIsSubpageOpened(true);
      // setIsEdit(false);
      setCallTable(false);
      const documentTitle = `${f({ id: 'table.add' })} - ${f({
        id: 'menu.costsOverview',
      })} - ${f({
        id: 'menu.costs',
      })}`;
      setDocumentTitle(documentTitle);
    } else if (params) {
      const documentTitle = `${f({ id: 'table.detail' })} - ${f({
        id: 'menu.costsOverview',
      })} - ${f({
        id: 'menu.costs',
      })}`;
      setDocumentTitle(documentTitle);
      setIsSubpageOpened(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <div>
      <PageHeader
        title={`${f({ id: 'menu.costs' })} / ${f({ id: 'menu.costsOverview' })}`}
        onlineHelpTopic="costs"
        show={!isSubpageOpened}
      />
      <div className="col-12">
        {!isSubpageOpened && (
          <DynamicTable
            name={TABLE_OPERATING_COSTS}
            noTab={true}
            mustClosed={false}
            buttons={
              PermissionsService.hasAccess(PERMISSION_COST, ['create'], selectedCustomers)
                ? buttons.costsOverview
                : undefined
            }
            updateTable={callTable}
            handleForm={handleSubpage}
            routerParams={params}
          />
        )}
      </div>
      {isSubpageOpened && params && customerIdUrl && (
        <CostsOverviewForm
          closeCallback={handleClose}
          selectedId={Number(params.id)}
          updateTable={updateTable}
          customerIds={Number(customerIdUrl)}
        />
      )}
      {isSubpageOpened && !params && (
        <CostsOverviewForm
          closeCallback={handleClose}
          selectedId={null}
          updateTable={updateTable}
        />
      )}
    </div>
  );
}
